import { LanguagesConfig, LocalizationConfig } from "@tm/localization"
import { ajax, setLocaleToLocalStorage } from "@tm/utils"
import { AppConfig } from "../data/loadConfiguration"

export async function loadLanguagesConfig(): Promise<LanguagesConfig | undefined> {
    try {
        const config = await ajax<LanguagesConfig>({ url: createLocaleUrl("language") })

        if (typeof config === "object") {
            return config
        }

        throw new Error(`Failed to load LanguagesConfig "language.json" (containing language mappings)`)
    } catch {
        return undefined
    }
}

export function createLocaleUrl(file: string): string {
    return `/locale/${file}.json`
}

export async function loadLocalizationConfig(languageId: string): Promise<LocalizationConfig | undefined> {
    try {
        const config = await ajax<LocalizationConfig | string>({ url: createLocaleUrl(languageId) })

        if (typeof config === "object") {
            return config
        }

        throw new Error(`Failed to load LocalizationConfig "${languageId}.json" (containing text id mappings)`)
    } catch {
        if (languageId !== "4") {
            return loadLocalizationConfig("4") // If config content is not valid load English config as fallback
        }

        return undefined
    }
}

/**
 * be sure to store the correct locales (regarding prio, sso > storage > appconfig)
 * @param localizationConfig languageConfig
 * @param appConfig application configuration with the white-/blacklist
 */
export function shouldStoreLocales(localizationConfig: LocalizationConfig, appConfig: AppConfig) {
    if (isLanguageAllowedByConfig(localizationConfig.id, appConfig)) {
        setLocaleToLocalStorage(localizationConfig.language, localizationConfig.id)
    }
}

export function isLanguageAllowedByConfig(languageId: string, config: AppConfig): boolean {
    const { languagesWhitelist = [], languagesBlacklist = [] } = config
    const isWhitelisted = languagesWhitelist.length > 0 ? languagesWhitelist.includes(languageId) : true
    const isBlacklisted = languagesBlacklist.includes(languageId)

    return isWhitelisted && !isBlacklisted
}
